import React, { useState, useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { 
  getFriendshipRecommendation, 
  mapDataToSocialProfile, 
  mapDataToFriendshipTracker 
} from '../utils/socialWellnessCoach';

const SocialWellnessCoach = ({ friendshipNeeds, friends, contactHistory }) => {
  const { t } = useTranslation();
  const [recommendation, setRecommendation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!friendshipNeeds) {
      setLoading(false);
      return;
    }

    try {
      // Map data to expected format
      const socialProfile = mapDataToSocialProfile(
        friendshipNeeds,
        friendshipNeeds.answers || {}
      );
      
      if (!socialProfile) {
        setLoading(false);
        return;
      }
      
      const friendshipTracker = mapDataToFriendshipTracker(friends || [], contactHistory || []);
      
      console.log('SocialWellnessCoach - friends:', friends?.length || 0);
      console.log('SocialWellnessCoach - friendshipTracker:', friendshipTracker?.length || 0);
      console.log('SocialWellnessCoach - friendshipNeeds:', friendshipNeeds);
      
      // Generate recommendation (pass friendshipNeeds for goal checking)
      const rec = getFriendshipRecommendation(socialProfile, friendshipTracker, friendshipNeeds);
      console.log('SocialWellnessCoach - recommendation:', rec);
      setRecommendation(rec);
    } catch (error) {
      console.error('Error generating recommendation:', error);
    } finally {
      setLoading(false);
    }
  }, [friendshipNeeds, friends, contactHistory]);

  if (loading) {
    return null; // Don't show loading state, just don't render
  }

  if (!recommendation) {
    return null;
  }

  return (
    <div className="social-wellness-coach">
      <div className="coach-header">
        <div className="coach-icon">💚</div>
        <h3>{t('todaysFriendshipAction')}</h3>
      </div>
      
      <div className="coach-recommendation">
        {recommendation.acknowledgment && (
          <p className="coach-acknowledgment">{recommendation.acknowledgment}</p>
        )}
        
        <div className="coach-action">
          <div className="action-arrow">→</div>
          <p className="action-text">{recommendation.action}</p>
        </div>
        
        <div className="coach-reason">
          <strong>{t('whyThisMatters')}</strong>
          <p>{recommendation.reason}</p>
        </div>
        
        {recommendation.howTo && (
          <div className="coach-howto">
            <strong>{t('howToDoIt')}</strong>
            <p>{recommendation.howTo}</p>
          </div>
        )}
        
        <div className="coach-effort">
          <strong>{t('effortLevel')}</strong>
          <span className="effort-badge">{recommendation.effort}</span>
        </div>
      </div>
    </div>
  );
};

export default SocialWellnessCoach;
